// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTable_wrapper__hHaMY","inputWrapper":"DataTable_inputWrapper__zd-Ir","inputContainer":"DataTable_inputContainer__4wRlv"};